const state = {
  soundSettingFinished: false
}

const mutations = {
  SET_SOUND_SETTING_FINISHED(state, payload) {
    state.soundSettingFinished = payload
  }
}

const actions = {
  setSoundSettingFinished({ commit }, value) {
    commit('SET_SOUND_SETTING_FINISHED', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
